import generalActions from './generalActions'
import shareActions from './shareActions'
import codeFormActions from './codeFormActions'
import signupActions from './signupActions'
import loginActions from './loginActions'
import binderActions from './binderActions'
import onboardingActions from './onboardingActions'
import adminOnboardingActions from './adminOnboardingActions'
import quizActions from './quizActions'
import pollActions from './pollActions'
import interactiveVideoActions from './interactiveVideoActions'
import sessionActions from './sessionActions'

const actions = {
	...generalActions,
	...shareActions,
	...codeFormActions,
	...signupActions,
	...loginActions,
	...binderActions,
	...onboardingActions,
	...adminOnboardingActions,
	...quizActions,
	...pollActions,
	...interactiveVideoActions,
	...sessionActions,
}

export default actions
